import { Injectable, inject } from '@angular/core';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { ServerResponse } from '@app/enums/server-response';
import { Store, select } from '@ngrx/store';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { LobbyService } from '../../../features/lobby/services/lobby.service';
import { of } from 'rxjs';
import { ROOT_EFFECTS_INIT } from '@ngrx/effects';

import * as CurrenciesActions from './currencies.actions';
import { WsService } from '@app/services/ws.service';
import { TableSummary, TableSummaryData } from '@app/models/table-summary';
import { LiveLobbyRing } from '@app/models/live-lobby-ring';
import { CurrencyService } from '@app/services/currency.service';
import { CurrencyInfoDTO } from '@app/models/currency-info';
import * as LobbyActions from '@app/store/features/lobby/lobby.actions';
import * as ConfigSelectors from '@app/store/features/config/config.selectors';
import { fi } from 'date-fns/locale';

@Injectable()
export class CurrenciesEffects {
    private readonly _ws = inject(WsService);
    private readonly _actions$ = inject(Actions);
    private readonly _store = inject(Store);
    private readonly _currencyService = inject(CurrencyService);

    // 


    currenciesInfo$ = createEffect(() => this._ws.getDataResponse<CurrencyInfoDTO[]>(ServerResponse.CurrenciesInfo)
        .pipe(
            // 🔧 FIX: Use switchMap with take(1) to complete inner subscriptions
            switchMap(currenciesInfoDTO =>
                this._store.pipe(
                    select(ConfigSelectors.getGlobalSettings),
                    filter(globalSettings => !!globalSettings),
                    take(1), // 🔧 FIX: Complete inner subscription
                    map(globalSettings => {
                        // Immutable update - no mutation
                        let currenciesData = currenciesInfoDTO;
                        if (currenciesInfoDTO.findIndex(curr => curr.id === 8) === -1) {
                            // Sometimes API does not return Tournament currency, so we add it manually
                            currenciesData = [
                                ...currenciesInfoDTO,
                                {
                                    id: 8,
                                    code: 'Tournament',
                                    name: 'Tournament',
                                    symbol: '',
                                    symbolAfter: false,
                                    multiplier: 1,
                                    nbDecimalVisible: 0,
                                    iso: 'Tournament',
                                    isVisibleToClient: true,
                                    withdrawMax: 0,
                                    withdrawMin: 0,
                                    rafEnabled: false,
                                    fdbEnabled: false
                                }
                            ];
                        }

                        const currencies = currenciesData.map(currencyInfoDTO => this._currencyService.updateCurrencyInfo(currencyInfoDTO, globalSettings!))
                        return CurrenciesActions.setAll({ currencies })
                    })
                )
            )
        ));

    changeCurrency$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(CurrenciesActions.selectCurrency),
                tap(({ selected }) => {
                    if (typeof Storage !== "undefined") {
                        localStorage.setItem('myCurrency', JSON.stringify(selected))
                    }
                }),
                map(({ selected }) => LobbyActions.onChangeCurrency({ currency: selected }))
            ));


    preSetCurrencyFromLocalStorage$ = createEffect(() =>
        this._actions$.pipe(
            ofType(CurrenciesActions.setAll),
           
            map(({ currencies }) => {
                if (typeof Storage !== "undefined") {
                    const stored = localStorage.getItem('myCurrency');
                    if (stored) {
                        try {
                            const selected = JSON.parse(stored);
                            // Find the currency by id in the loaded currencies array
                            const exists = currencies.find((c: any) => c.id === selected.id);
                            console.log('Currency exists:', exists);
                            if (exists) {
                                return CurrenciesActions.selectCurrency({ selected });
                            }
                        } catch (e) {
                            // Ignore parse errors
                        }
                    }
                }
                // Return a noop action if nothing to do
                return { type: '[Currencies] Noop' };
            })
        )
    );
}
